appSocial.component('tradesList', {
    templateUrl: 'widgets/leader-detail/components/trades-list/TradesListComponent.html',
    bindings: {
        trades: '<'
    },
    controller: [
        'SocialConstants',
        'SocialLocaleService',
        class TradesListComponent {
            constructor(SocialConstants,
                        SocialLocaleService) {
                this.constants = SocialConstants;
                this.translation = SocialLocaleService.translation;

                this.allItems = [];
                this.items = [];
            }

            $onInit() {
                this.allItems = this.trades;
                // to show last 10 records only
                // this.items = this.allItems.splice(0, 10);
                this.items = this.allItems;
            }

            $onChanges(changes) {
                if (changes.trades && changes.trades.currentValue) {
                    this.allItems = this.trades;
                    // to show last 10 records only
                    // this.items = this.allItems.splice(0, 10);
                    this.items = this.allItems;
                }
            }

            $onDestroy() {
                this.items = null;
                this.allItems = null;
            }

            toggle(trade) {
                trade.expanded = !trade.expanded;
            }

        }]
})
